import React, { useState } from "react";
import { NoEmployees } from "./NoEmployees";
import {
  EmployeeArea,
  EmployeeDuration,
  EmployeePosition,
} from "./EmployeeTableRow";
import { Icon, Loader, Table, Button, Popup } from "semantic-ui-react";
import { useAsync } from "react-async";
import { AxiosEmployeeAPI, AxiosEmployeeManagerAPI } from "../Api";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { toast } from "react-toastify";
import { ToastId } from "../../common/ToastIds";
import { useAuth } from "../../utils/Auth";
import { EmployeeExpandableCell } from "./EmployeeTeamList";
import { useHistory } from "react-router-dom";

export const EmployeeSecondaryTeamTableRow = ({ employee, deep }) => {
  const [open, setOpen] = useState(false);
  let area = employee.current_area?.area;
  let position = employee.current_position?.position;
  const { reload } = useAuth();
  const { run, error } = useAsync({
    deferFn: async (args, props, controller) => {
      await AxiosEmployeeAPI.changeActiveEmployee(args, props, controller);
      reload();
    },
  });
  let history = useHistory();

  const handleActiveEmployeeChange = (employee) => {
    run({ employee_code: employee.employee_code });
    history.push("/minha_equipe/");
  };

  if (error) {
    toast.error(
      "Não foi possível trocar o funcionário ativo!",
      ToastId.ERROR_ACTIVE_EMPLOYEE,
    );
  }

  return (
    <>
      <Table.Row id={employee.id}>
        <Table.Cell id={"name"}>
          <EmployeeExpandableCell
            employee={employee}
            setOpen={setOpen}
            open={open}
            deep={deep}
          />
        </Table.Cell>
        <Table.Cell id={"time"}>
          <EmployeeDuration employee={employee} />
        </Table.Cell>
        <Table.Cell id={"position"}>
          <EmployeePosition position={position} />
        </Table.Cell>
        <Table.Cell id={"area"}>
          <EmployeeArea area={area} />
        </Table.Cell>
        <Table.Cell id={"action"}>
          {deep === 0 ? (
            <Button onClick={() => handleActiveEmployeeChange(employee)}>
              Visualizar como {employee.name}
            </Button>
          ) : null}
        </Table.Cell>
      </Table.Row>
      {open ? (
        <EmployeeSecondaryTeamTable employee_id={employee.id} deep={deep + 1} />
      ) : null}
    </>
  );
};

const EmployeeSecondaryTeam = ({ employees, reload, deep }) => {
  const { user } = useAuth();
  return employees
    .filter((employee) => employee.id !== user.active_employee.id)
    .map((employee) => (
      <EmployeeSecondaryTeamTableRow
        key={employee.id}
        employee={employee}
        reload={reload}
        deep={deep}
      />
    ));
};

const EmployeeSecondaryTeamTable = ({ employee_id, deep }) => {
  const { data, isPending, error, reload } = useAsync({
    promiseFn:
      deep === 0
        ? AxiosEmployeeAPI.getAuthorizedEmployees
        : AxiosEmployeeManagerAPI.getTeam,
    employee_id: employee_id,
  });
  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;

  if (data.length === 0) {
    return <NoEmployees message="Este funcionário não possui time!" />;
  }

  return <EmployeeSecondaryTeam employees={data} reload={reload} deep={deep} />;
};

export const EmployeeSecondaryTeamList = ({ employee_id }) => {
  if (employee_id)
    return (
      <Table selectable padded="very" style={{ marginBottom: "2rem" }}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Nome</Table.HeaderCell>
            <Table.HeaderCell>No time desde</Table.HeaderCell>
            <Table.HeaderCell>Cargo</Table.HeaderCell>
            <Table.HeaderCell>Área</Table.HeaderCell>
            <Table.HeaderCell>
              <span>
                Ações
                <Popup
                  content={
                    "Ao clicar nos botões abaixo, você terá a visão espelhada da pessoa selecionada"
                  }
                  trigger={<Icon color={"grey"} name={"info circle"} />}
                />
              </span>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <EmployeeSecondaryTeamTable employee_id={employee_id} deep={0} />
        </Table.Body>
      </Table>
    );

  return null;
};
